/**
 * @generated SignedSource<<90cca27c72ae57afe4ef88e2946b131a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSidebarPromotionForm_item$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "CheckoutSidebarPromotionForm_item";
};
export type CheckoutSidebarPromotionForm_item$key = {
  readonly " $data"?: CheckoutSidebarPromotionForm_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebarPromotionForm_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSidebarPromotionForm_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "84b593ab75eb6faecaed06b928655d5a";

export default node;
